import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";

interface HorizontalChartProps {
  savings?: number;
  informalDebts?: number;
  formalDebts?: number;
}
export const HorizontalChart = ({
  savings,
  informalDebts,
  formalDebts,
}: HorizontalChartProps) => {
  const [data, setData] = useState<any[]>([]);
  const [showGraph, setShowGraph] = useState(false);
  const dataGraph = [
    {
      title: "Ahorros",
      formal: savings,
      formalColor: "#F2609E",
      informal: 0,
      informalColor: "#F2609E",
    },
    {
      title: "Deudas",
      formal: informalDebts,
      formalColor: "#7849B8",
      informal: formalDebts,
      informalColor: "#AEA9F4",
    },
  ];

  useEffect(() => {
    setData(dataGraph);
  }, []);

  useEffect(() => {
    setShowGraph(true);
  }, [data]);

  useEffect(() => {
    setData(dataGraph);
  }, [showGraph]);

  return showGraph ? (<>
    <div data-testid="horizontal"> </div>
    <ResponsiveBar
      data={data}
      keys={["formal", "informal"]}
      indexBy="title"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      layout="horizontal"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      isInteractive={false}
      enableLabel={false}
      colors={({ id, data }) => data[`${id}Color`]}
      enableGridY={false}
      borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: "middle",
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      role="application"
    />
  </>
  ) : (
    <></>
  );
};
